import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CreateSmartLinkEmbedMutation: GraphQLTaggedNode = graphql`
	mutation CreateSmartLinkEmbedMutation(
		$contentSpecificCreateInput: [ContentSpecificCreateInput!]
		$parentId: ID
		$spaceKey: String
		$title: String
		$type: String!
		$status: GraphQLContentStatus!
	) {
		createContentContextual(
			input: {
				contentSpecificCreateInput: $contentSpecificCreateInput
				parentId: $parentId
				spaceKey: $spaceKey
				title: $title
				type: $type
				status: $status
			}
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
